import Accordion from '@components/Accordion';
import Column from '@components/Column';
import Image from '@components/Image';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { GiftItemRow } from '@models/gift';

import styles from './styles.module.scss';

interface Props {
    giftItem: GiftItemRow;
    qty: number;
}

function ItemInfo({ giftItem, qty }:Props) {
  const { name, imageUrl, salePrice } = giftItem;
  return (
        <div className={styles.wrapper}>
            <Accordion title='선물 상품'
                       initialOpen
                       className={styles.accordion}
                       handleClassName={styles.accordionHandle}
                       titleClassName={styles.title}>
                <Row className={styles.contents}
                     spacing={16}
                     align='flex-start' >
                    <div className={styles.image}>
                        <Image src={imageUrl}
                               width={72}
                               height={72}
                               alt=''/>
                    </div>
                    <Column>
                        <Text size='lg' fontWeight='bold' color={colors.gray6}>
                            {name}
                        </Text>
                        <Row spacing={8}>
                            <Text color={colors.gray8}>{qty}개</Text>
                            <div className={styles.dot} />
                            <Text color={colors.gray8}>{(salePrice * qty).toLocaleString()}원</Text>
                        </Row>
                    </Column>
                </Row>
            </Accordion>
        </div>
  );
}

export default ItemInfo;
